<template>
	<b-container>
		<b-form @submit.prevent="createContact">
			<b-row class="mt-3">
				<b-col md="2" offset-md="10">
					<b-button type="submit" variant="outline-success">Save</b-button>

					<b-button :to="{ name: 'contacts' }" variant="outline-danger">Cancel</b-button>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<h1>{{ contact.Name }}</h1>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Title:" for="title">
						<b-col>
							<b-input id="title" v-model="contact.Title" maxlength="10" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Name:" for="name">
						<b-col>
							<b-input id="name" v-model="contact.Name" type="text" required />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Position:" for="position">
						<b-col>
							<b-input id="position" v-model="contact.Position" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Email:" for="email">
						<b-col>
							<b-input id="email" v-model="contact.EmailAddress" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Telephone:" for="telephone">
						<b-col>
							<b-form-input id="telephone" v-model="contact.Telephone" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Mobile:" for="mobile">
						<b-col>
							<b-form-input id="mobile" v-model="contact.Mobile" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Notes:" for="notes">
						<b-col>
							<b-textarea id="notes" v-model="contact.Description" type="text" />
						</b-col>
					</b-form-group>
				</b-col>

				<b-col>
					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 1:" for="address1">
						<b-col>
							<b-input id="address1" v-model="contact.Address.Address1" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 2:" for="address2">
						<b-col>
							<b-input id="address2" v-model="contact.Address.Address2" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Address 3:" for="address3">
						<b-col>
							<b-input id="address3" v-model="contact.Address.Address3" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Town:" for="town">
						<b-col>
							<b-input id="town" v-model="contact.Address.Town" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="County:" for="county">
						<b-col>
							<b-input id="county" v-model="contact.Address.County" type="text" />
						</b-col>
					</b-form-group>

					<b-form-group :label-cols="2" breakpoint="md" horizontal label="Postcode:" for="postcode">
						<b-col>
							<b-input id="postcode" v-model="contact.Address.Postcode" type="text" />
						</b-col>
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>

		<b-modal ref="alertModal" :title="alertModalTitle" :ok-only="true" @ok="onAlertModalOkClick">
			<p class="my-4">{{ alertModalContent }}</p>
		</b-modal>
	</b-container>
</template>

<script>
import ContactService from '@/api-services/contact.service';

export default {
	name: 'ContactCreate',
	data() {
		return {
			contact: {
				Address: {}
			},

			alertModalTitle: '',
			alertModalContent: '',
			isSuccess: false
		};
	},

	methods: {
		createContact() {
			ContactService.create(this.contact)
				.then(() => {
					this.isSuccess = true;
					this.alertModalTitle = 'Success';
					this.alertModalContent = 'Successfully created Contact';
					this.$refs.alertModal.show();
				})
				.catch((error) => {
					this.isSuccess = false;
					this.alertModalTitle = 'Error';
					this.alertModalContent = error.response.data;
					this.$refs.alertModal.show();
				});
		},

		onAlertModalOkClick() {
			if (this.isSuccess) {
				this.$router.push({ name: 'contacts' });
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/contact/contact-create.vue